// extracted by mini-css-extract-plugin
module.exports = {"group":"CheckboxGroup_group__1SSIB"};